module.exports = __webpack_public_path__ + "static/media/KEITH MONKS REDUX DISCOVERY ONE.4950d70f.png";